export enum InvoiceStatus {
  TotalPaid = 'TotalPaid',
  TotalUnpaid = 'TotalUnpaid',
  TotalDue = 'TotalDue',
  NoPaidInvoices = 'NoPaidInvoices',
  NoUnPaidInvoices = 'NoUnPaidInvoices',
  NoDueInvoices = 'NoDueInvoices',
  PAID = 'PAID',
  UNPAID = 'UNPAID',
  REJECTED = 'REJECTED',
  DRAFTED = 'DRAFTED',
  IN_PROGRESS = 'IN_PROGRESS',
  OverDue = 'OVER_DUE',
  UNDER_REVIEW = 'UNDER_REVIEW',
  WAITING_FOR_PAYMENT = 'WAITING_FOR_PAYMENT',
  PAYMENT_FAILED = 'PAYMENT_FAILED',
  CASH_ON_DELIVERY = 'CASH_ON_DELIVERY',
}
